import Bugsnag from '@bugsnag/js';
import axios, { AxiosError } from 'axios';

export type ConfigEnvAF = typeof import('@/assets/config/config.sample.json');

export async function fetchEnv() {
  const path =
    process.env.NODE_ENV === 'development'
      ? `${window.location.origin}/src/assets/config/config.json`
      : `${window.location.origin}/assets/config.json`;

  try {
    const environnement = await axios.get<ConfigEnvAF>(path);

    const { data } = environnement;
    return data;
  } catch (error) {
    if (process.env.NODE_ENV === 'development') console.log(error);

    if (
      !(error instanceof AxiosError) ||
      (error instanceof AxiosError && error.response?.status !== 401)
    ) {
      Bugsnag.notify(error, event => {
        event.context = 'Failed to load environment configuration file';
      });
    }
  }
}
